export const ColorPairs = [
    { backgroundColor: '#D5E7DC', color: '#155231' },
    { backgroundColor: '#FEE9B0', color: '#6F3B01' },
    { backgroundColor: '#DBEAFE', color: '#1E3A8A' },
    { backgroundColor: '#EDE2D1', color: '#4A3F2A' },
    { backgroundColor: '#FFE5EC', color: '#831843' },
    // Yeni eklenenler:
    { backgroundColor: '#DDF5F0', color: '#2E3E3E' },     // Mint & Gri
    { backgroundColor: '#FFE3D3', color: '#5D2E1A' },     // Şeftali & Çikolata
    { backgroundColor: '#EDE6F7', color: '#4B2666' },     // Lila & Mor
    { backgroundColor: '#F8F1D9', color: '#3E320C' },     // Vanilya & Koyu Hardal
    { backgroundColor: '#D8ECF3', color: '#1A3C4B' },     // Açık Mavi & Lacivert
];
